import { Component, Injectable, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

@Injectable()
@Component({
    selector: 'soaviewsubmissionconf',
        templateUrl: 'soa-form-submission-confirmation.html'


})
export class SOAFormSubmissionConfirmationComponent implements OnInit {

    BeneficaryEmail: string
    constructor(private route: ActivatedRoute) {

    }

    ngOnInit() {

        this.route
            .params
            .subscribe(params => {
                this.BeneficaryEmail = params['BeneficaryEmail']
            })

    }

}
